module.exports = __webpack_public_path__ + "static/media/wise.bf6da2f0.svg";